import type { EntityImage } from './entityImages'

/**
 * Imágenes individuales de ítems o variantes proporcionadas por el staff, por ID exacto (item_id o variant_id).
 * Tienen prioridad sobre la celda de la lámina. Identifican el objeto; no confirman drops ni contenido.
 */
const CDN = 'https://cdn.magicpatterns.com/uploads'
const DATE = '10/10/2026'
const staff = (src: string, matchedBy: string): EntityImage => ({ src, origin: 'staff', addedOn: DATE, matchedBy })
const BOX = 'Archivo box_kundunN del staff → variante 14,11 de nivel N + 7 (02_item_variants: "Box of Kundun N")'

export const staffItemImages: Record<string, EntityImage> = {
  '14,11@8': staff(`${CDN}/nzzMtxFimxznF4bRhXXmkJ/box_kundun1.png.webp`, BOX),
  '14,11@9': staff(`${CDN}/fNt1GPybvXtwAeTVmyuASk/box_kundun2.png`, BOX),
  '14,11@10': staff(`${CDN}/bc5akJGMjjeCtDAPiectcZ/box_kundun3.png`, BOX),
  '14,11@11': staff(`${CDN}/tnTefCCnnLoMN9a1PAhPMi/box_kundun4.png`, BOX),
  '14,11@12': staff(`${CDN}/h6w3EcUJGjqQVUotEsQK1A/box_kundun5.png`, BOX),
}

export const staffItemImage = (id?: string) => (id ? staffItemImages[id.trim()] : undefined)
